export const FEED_FETCH_REQUEST = 'dashboard_feed_fetch_request';
export const FEED_FETCH_SUCCESS = 'dashboard_feed_fetch_success';
export const FEED_FETCH_FAILURE = 'dashboard_feed_fetch_failure';


export const USER_DAILY_STATS_REQUEST = 'user_daily_stats_request';
export const USER_DAILY_STATS_SUCCESS = 'user_daily_stats_success';
export const USER_DAILY_STATS_FAILURE = 'user_daily_stats_failure';
